import { ColDef } from 'ag-grid-community';
import { useMemo } from 'react';
import AllCompaniesActionsCellRenderer from '../components/cellRenderers/AllCompaniesActionsCellRenderer';
import { entityFormatter } from '../../../common/GridFormatters';
import { useCommonKpiColDefs } from '../../KPIRequests/hooks/useCommonKpiColDefs';

export const CompanyColId = 'company';

/**@deprecated */
export function useKPICompaniesAllColDefs() {
  const { respondentColDef, secondaryRespondentColDef, commonCompanyDefs } = useCommonKpiColDefs();

  const columnDefs: ColDef[] = useMemo(() => {
    const defs: ColDef[] = [
      {
        ...commonCompanyDefs,
        rowGroup: true,
        keyCreator: (params) => `${params.value?.name}-${params.value?.id}`,
        enableRowGroup: true,
      },
      {
        field: 'sector',
        headerName: 'Sector',
        valueGetter: (params) => {
          if (!params.data?.sector) {
            return '';
          }

          return params.data?.sector.name ?? '';
        },
        enableRowGroup: true,
      },
      {
        field: 'template',
        headerName: 'Template',
        valueGetter: (params) => {
          if (!params.data?.template) {
            return '';
          }
          return params.data?.template.name;
        },
        enableRowGroup: true,
      },
      {
        field: 'frequency',
        headerName: 'Frequency',
        valueFormatter: entityFormatter,
        enableRowGroup: true,
      },
      respondentColDef,
      secondaryRespondentColDef,
      {
        field: '',
        maxWidth: 60,
        pinned: 'right',
        sortable: false,
        resizable: false,
        cellRenderer: AllCompaniesActionsCellRenderer,
      },
    ];
    return defs;
  }, [commonCompanyDefs, respondentColDef, secondaryRespondentColDef]);

  const defaultColDef = useMemo<ColDef>(
    () => ({
      flex: 1,
      minWidth: 120,
      resizable: true,
      sortable: true,
      filter: false,
      suppressHeaderMenuButton: true,
      suppressHeaderFilterButton: true,
      getQuickFilterText: () => {
        return '';
      },
    }),
    []
  );

  return {
    columnDefs,
    defaultColDef,
  };
}
